import {
  createProperty,
  deleteProperty,
  getProperty,
  getProperyFileDetails,
  removePropertyPhoto,
  setFileAsPropertyPhoto,
  updateProperty,
} from '../thunks/property';
import { handlePending, handleRejected } from './utils';

export const propertyReducers = (builder) => {
  // create property
  builder
    .addCase(createProperty.fulfilled, (state, action) => {
      const allProperties = [...state.allProperties.value];
      const { property } = action.payload;
      allProperties.push({ ...property, access: ['Read', 'Write'] });
      state.allProperties.value = allProperties;
      state.newPropertyForm.loading = false;
    })
    .addCase(createProperty.pending, (state) => handlePending(state, 'newPropertyForm'))
    .addCase(createProperty.rejected, (state) => handleRejected(state, 'newPropertyForm'));

  // update property
  builder
    .addCase(updateProperty.fulfilled, (state, action) => {
      const allProperties = [...state.allProperties.value];
      const property = action.payload;
      const propertyIndex = allProperties.findIndex((item) => item.id === property.id);
      const updatedProperty = { ...allProperties[propertyIndex], ...property };
      if (propertyIndex >= 0) {
        allProperties[propertyIndex] = updatedProperty;
      }
      state.selectedProperty = updatedProperty;
      state.allProperties.value = allProperties;
      state.editPropertyForm.loading = false;

      if (state.currentProperty?.oid === property.id || state.currentProperty.id === property.id) {
        state.currentProperty = {
          ...state.currentProperty,
          name: property.name,
          overview: {
            ...state.currentProperty.overview,
            address: property.address,
          },
        };
      }
    })
    .addCase(updateProperty.pending, (state) => handlePending(state, 'editPropertyForm'))
    .addCase(updateProperty.rejected, (state) => handleRejected(state, 'editPropertyForm'));

  // delete property
  builder.addCase(deleteProperty.fulfilled, (state, action) => {
    const allProperties = [...state.allProperties.value];
    const id = action.payload;
    const propertyIndex = allProperties.findIndex((item) => item.id === id);
    if (propertyIndex >= 0) {
      allProperties.splice(propertyIndex, 1);
    }
    state.allProperties.value = allProperties;
  });

  // set property file details
  builder
    .addCase(getProperyFileDetails.fulfilled, (state, action) => {
      state.currentProperty = action.payload;
    })
    .addCase(getProperyFileDetails.rejected, (state) => {
      state.currentProperty = null;
    });

  // set property
  builder
    .addCase(getProperty.fulfilled, (state, action) => {
      state.selectedProperty = action.payload;
    })
    // .addCase(getProperty.pending, (state) => {
    //   state.selectedProperty = null;
    // })
    .addCase(getProperty.rejected, (state) => {
      state.selectedProperty = null;
    });

  // update selected property preview
  builder.addCase(setFileAsPropertyPhoto.fulfilled, (state, action) => {
    const selectedProperty = { ...state.selectedProperty };
    const { id } = action.payload;
    state.selectedProperty = { ...selectedProperty, preview_file_id: id };
  });

  builder.addCase(removePropertyPhoto.fulfilled, (state) => {
    // update selected property and remove its preview_file_id
    const selectedProperty = state.selectedProperty ?? {};
    const selectedPropertyWithoutPreview = Object.fromEntries(
      Object.entries(selectedProperty).filter(([key]) => key !== 'preview_file_id')
    );
    state.selectedProperty = selectedPropertyWithoutPreview;

    // update my properties list
    const myProperties = [...state.myProperties.value];
    const propertyIndex = myProperties.findIndex((item) => item.id === selectedProperty.id);
    if (propertyIndex >= 0) {
      myProperties[propertyIndex] = selectedPropertyWithoutPreview;
    }
    state.myProperties.value = myProperties;
  });
};
